import React from 'react'
import { Row, Col } from 'reactstrap'

function AddHeader({ title }) {
  return (
    <Row className="form-header mb-4">
      <Col>
        <h1>{title}</h1>
      </Col>
    </Row>
  )
}

export default AddHeader